import { render } from "./ElectricalControl.vue?vue&type=template&id=10e0395c&scoped=true"
import script from "./ElectricalControl.vue?vue&type=script&lang=js"
export * from "./ElectricalControl.vue?vue&type=script&lang=js"

import "./ElectricalControl.vue?vue&type=style&index=0&id=10e0395c&scoped=true&lang=css"
import "./ElectricalControl.vue?vue&type=style&index=1&id=10e0395c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10e0395c"]])

export default __exports__